import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { storeWithExpiration } from '../../utils/common';
import {
  SUPER_ADMIN,
  PROVIDER_ADMIN,
  PROVIDER_TECHNICAL,
  PROVIDER_SALES_OPS,
} from '../../config/app_config';
import {
  clearFieldsForSku,
  enableDatasetVersion,
  deleteDatasetVersion,
  fetchDatasetRecordCount,
  fetchDatasetsById,
  fetchFilesets,
  fetchFieldsetsById,
  fetchSingleDatasetById,
  fetchVersions,
  getFieldsForSku,
  goToEditFieldset,
  listFields,
  openConfigForm,
  openEditList,
  openEditSku,
  openFilesetPreview,
  openDatasetReportsPage,
  openGroupCreation,
  openSkuCreation,
} from '../../actions/data';
import { fetchPlatforms, openFilesetPage } from '../../actions/superadmin';
import { openDialog, closeDialog } from '../../actions/dialog';
import SingleDataset from './SingleDataset';
import DialogForm from '../shared/DialogForm';
import PreviewSkuDialog from './PreviewSkuDialog';

export class SingleDatasetContainer extends React.Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    clearFieldsForSkuAction: PropTypes.func.isRequired,
    closeDialogAction: PropTypes.func.isRequired,
    currentFilesets: PropTypes.object.isRequired,
    currentSkuFields: PropTypes.object.isRequired,
    dataSet: PropTypes.object,
    datasetId: PropTypes.string.isRequired,
    deleteVersionAction: PropTypes.func.isRequired,
    dialog: PropTypes.object.isRequired,
    enableVersionAction: PropTypes.func.isRequired,
    fetchDatasetRecordCountAction: PropTypes.func.isRequired,
    fetchFieldsetsByIdAction: PropTypes.func.isRequired,
    fetchFilesetsAction: PropTypes.func.isRequired,
    fetchPlatformsAction: PropTypes.func.isRequired,
    fetchSingleDatasetByIdAction: PropTypes.func.isRequired,
    fetchVersionsAction: PropTypes.func.isRequired,
    fieldSets: PropTypes.object.isRequired,
    getFieldsForSkuAction: PropTypes.func.isRequired,
    goToEditFieldsetAction: PropTypes.func.isRequired,
    isProviderAdmin: PropTypes.bool.isRequired,
    isSalesOps: PropTypes.bool.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    isTechnicalOps: PropTypes.bool.isRequired,
    listFieldsAction: PropTypes.func.isRequired,
    openConfigFormAction: PropTypes.func.isRequired,
    openDatasetReportsPageAction: PropTypes.func.isRequired,
    openDialogAction: PropTypes.func.isRequired,
    openEditListAction: PropTypes.func.isRequired,
    openEditSkuAction: PropTypes.func.isRequired,
    openFilesetPageAction: PropTypes.func.isRequired,
    openFilesetPreviewAction: PropTypes.func.isRequired,
    openGroupCreationAction: PropTypes.func.isRequired,
    openSkuCreationAction: PropTypes.func.isRequired,
    platforms: PropTypes.object,
    recordsSummary: PropTypes.object.isRequired,
    skuFields: PropTypes.object.isRequired,
    versionsSummary: PropTypes.object.isRequired,
  };

  static defaultProps = {
    dataSet: undefined,
    platforms: null,
  };

  constructor(props) {
    super(props);
    this.handleVersionSelectChange = this.handleVersionSelectChange.bind(this);
  }

  state = {
    currentSku: {},
    currentDatasetId: 0,
    currentDatasetName: '',
    datasetState: '',
    selectedVersion: '',
    permissionToEdit: false,
  };

  componentWillMount = () => {
    const {
      datasetId,
      fetchFilesetsAction,
      fetchFieldsetsByIdAction,
      fetchDatasetRecordCountAction,
      fetchVersionsAction,
      fetchSingleDatasetByIdAction,
      isSuperAdmin,
    } = this.props;

    const token = storeWithExpiration.get('token');
    fetchDatasetRecordCountAction(datasetId, undefined, token);
    fetchVersionsAction(datasetId, token);
    fetchFieldsetsByIdAction(datasetId, undefined, token); // undefined gets 'SKU' and 'GROUPS'
    fetchSingleDatasetByIdAction(datasetId, token);
    fetchFilesetsAction(datasetId, token);
    if (isSuperAdmin) this.props.fetchPlatformsAction();
  };

  setSelectedVersion = value => {
    this.setState({ selectedVersion: value });
  };

  handleVersionSelectChange(e) {
    const { value } = e.target;
    this.setState({ selectedVersion: value });
    this.toggleDialog('versionDialog');
  }

  toggleDialog = id => {
    const { dialog, openDialogAction, closeDialogAction } = this.props;
    if (
      dialog.show &&
      (dialog.id === 'editLayoutDialog' ||
        dialog.id === 'editSkuDialog' ||
        dialog.id === 'viewLayoutDialog' ||
        dialog.id === 'versionDialog')
    ) {
      closeDialogAction(id);
    } else {
      openDialogAction(id);
    }
  };

  togglePreviewDialog = (sku, datasetId, datasetName, datasetState, id) => {
    const {
      dialog,
      openDialogAction,
      closeDialogAction,
      isSuperAdmin,
      isProviderAdmin,
      isTechnicalOps,
      isSalesOps,
    } = this.props;

    if (dialog.show && dialog.id === 'skuPreviewDialog') {
      this.setState({
        currentSku: {},
        currentDatasetId: 0,
        currentDatasetName: '',
        datasetState: '',
        permissionToEdit: false,
      });
      closeDialogAction(id);
    } else {
      const permission = isSuperAdmin || isProviderAdmin || isTechnicalOps || isSalesOps;
      this.setState({
        currentSku: sku,
        currentDatasetId: datasetId,
        currentDatasetName: datasetName,
        datasetState,
        permissionToEdit: permission,
      });
      openDialogAction(id);
    }
  };

  cancelVersionDialog = id => () => {
    const { closeDialogAction, datasetId, versionsSummary } = this.props;
    const versions = versionsSummary.get(datasetId);
    const activeVersion = versions.filter(v => v.status === 1)[0].version;
    closeDialogAction(id);
    this.setState({ selectedVersion: activeVersion });
  };

  cancelEditDialog = id => () => {
    const { closeDialogAction } = this.props;
    closeDialogAction(id);
  };

  cancelPreviewDialog = id => {
    const { closeDialogAction } = this.props;
    this.setState({
      currentSku: {},
      currentDatasetId: 0,
      currentDatasetName: '',
      datasetState: '',
    });
    closeDialogAction(id);
  };

  performEnableVersion = (datasetId, versionId) => {
    const { enableVersionAction, fetchVersionsAction } = this.props;
    const token = storeWithExpiration.get('token');
    const prom = new Promise(resolve => {
      enableVersionAction(token, datasetId, versionId, resolve);
    });
    prom.then(() => {
      fetchVersionsAction(datasetId, token);
    });
  };

  performDeleteVersion = (datasetId, versionId) => {
    const { deleteVersionAction, fetchVersionsAction } = this.props;
    const token = storeWithExpiration.get('token');
    // eslint-disable-next-line
    if (window.confirm('Are you sure you want to delete this version?')) {
      const prom = new Promise(resolve => {
        deleteVersionAction(token, datasetId, versionId, resolve);
      });
      prom.then(() => {
        fetchVersionsAction(datasetId, token);
      });
    }
  };

  renderViewLayoutDialog = () => {
    const { dialog } = this.props;

    const content = (
      <div className="container">
        <p>The view layout feature is coming soon.</p>
        <p>
          <button
            className="btn btn-primary pull-right"
            onClick={this.cancelEditDialog('viewLayoutDialog')}
          >
            Okay
          </button>
        </p>
        <br />
        <br />
      </div>
    );

    return (
      <DialogForm
        cancelFunction={this.cancelEditDialog('viewLayoutDialog')}
        cancelText="Okay"
        content={content}
        id="viewLayoutDialog"
        show={dialog.show}
        title="View Layout"
      />
    );
  };

  renderEditLayoutDialog = () => {
    const { dialog } = this.props;

    const content = (
      <div className="container">
        <p>The edit layout feature is expected in late 2016.</p>
        <p>
          <button
            className="btn btn-primary pull-right"
            onClick={this.cancelEditDialog('editLayoutDialog')}
          >
            Okay
          </button>
        </p>
        <br />
        <br />
      </div>
    );

    return (
      <DialogForm
        cancelFunction={this.cancelEditDialog('editLayoutDialog')}
        cancelText="Okay"
        content={content}
        id="editLayoutDialog"
        show={dialog.show}
        title="Edit Layout"
      />
    );
  };

  renderEditSkuDialog = () => {
    const { dialog } = this.props;

    const content = (
      <div className="container">
        <p>This SKU is in use by at least one order and cannot be edited at this time</p>
        <p>
          <button
            className="btn btn-primary pull-right"
            onClick={this.cancelEditDialog('editSkuDialog')}
          >
            Okay
          </button>
        </p>
        <br />
        <br />
      </div>
    );

    return (
      <DialogForm
        cancelFunction={this.cancelEditDialog('editSkuDialog')}
        cancelText="Okay"
        content={content}
        id="editSkuDialog"
        show={dialog.show}
        title="Edit Sku"
      />
    );
  };

  renderVersionDialog = () => {
    const { dialog, dataSet, closeDialogAction, isSuperAdmin, versionsSummary } = this.props;
    const { selectedVersion } = this.state;
    const versions = versionsSummary.get(dataSet.id.toString());
    const version = versions.filter(v => v.version === parseInt(selectedVersion, 10))[0];
    const content = (
      <div className="container">
        <p>Are you sure you want to set this version as Live?</p>
        {isSuperAdmin ? <p>Or would you like to delete this version?</p> : null}
        <p className="card-text">
          <span className="pull-right">
            <button
              className="btn btn-secondary btn-back"
              data-dismiss="modal"
              onClick={this.cancelVersionDialog('versionDialog')}
            >
              Cancel
            </button>
            {isSuperAdmin && versions !== undefined && versions.length !== 0 ? (
              <button
                type="button"
                className="btn btn-default btn-md"
                onClick={() => {
                  this.performDeleteVersion(dataSet.id, version.id);
                  closeDialogAction('versionDialog');
                }}
              >
                Delete Version
              </button>
            ) : null}
            <button
              className="btn btn-primary"
              onClick={() => {
                this.performEnableVersion(dataSet.id, version.id);
                closeDialogAction('versionDialog');
              }}
            >
              {isSuperAdmin ? 'OK' : 'Set as Live'}
            </button>
          </span>
        </p>
        <br />
        <br />
      </div>
    );

    return (
      <DialogForm
        cancelFunction={this.cancelVersionDialog('versionDialog')}
        cancelText="Cancel"
        content={content}
        id="versionDialog"
        show={dialog.show}
        title="Enable Live Version"
      />
    );
  };

  renderPreviewDialog = () => {
    const {
      dialog,
      listFieldsAction,
      getFieldsForSkuAction,
      closeDialogAction,
      skuFields,
      currentSkuFields,
      currentFilesets,
      openEditSkuAction,
      goToEditFieldsetAction,
      clearFieldsForSkuAction,
    } = this.props;
    const {
      currentSku,
      currentDatasetId,
      currentDatasetName,
      datasetState,
      permissionToEdit,
    } = this.state;

    return (
      <PreviewSkuDialog
        dialog={dialog}
        closeDialogFunction={closeDialogAction}
        listFieldsFunction={listFieldsAction}
        getFieldsForSkuFunction={getFieldsForSkuAction}
        goToEditFieldsetFunction={goToEditFieldsetAction}
        datasetFields={skuFields}
        currentSkuFields={currentSkuFields}
        currentFilesets={currentFilesets}
        datasetId={currentDatasetId}
        currentSku={currentSku}
        datasetName={currentDatasetName}
        datasetState={datasetState}
        openEditSkuFunction={openEditSkuAction}
        clearFieldsForSkuFunction={clearFieldsForSkuAction}
        isAdminPage={false}
        permissionToEdit={permissionToEdit}
      />
    );
  };

  render() {
    const {
      account,
      dataSet,
      datasetId,
      dialog,
      fetchDatasetRecordCountAction,
      fieldSets,
      isProviderAdmin,
      isTechnicalOps,
      isSalesOps,
      isSuperAdmin,
      openConfigFormAction,
      openEditListAction,
      goToEditFieldsetAction,
      openFilesetPageAction,
      openFilesetPreviewAction,
      openDatasetReportsPageAction,
      openGroupCreationAction,
      openSkuCreationAction,
      platforms,
      recordsSummary,
      versionsSummary,
    } = this.props;

    // for consistency between data index and admin view
    // const dataSetsList = new List(dataSets.valueSeq().map((set) => set));
    const versions = versionsSummary.get(datasetId);

    return (
      <div className="modal-wrap">
        <div className="container-fluid container-home">
          <div className="header">
            <div className="header-body">
              <div className="row">
                <div className="col-sm-12">
                  <h1 className="header-title">
                    {isSuperAdmin ? (
                      <Link to="/superadmin/listsummary">
                        <i className="fa fa-angle-left" /> Overview of Customer Datasets
                      </Link>
                    ) : (
                      <Link to="/data">
                        <i className="fa fa-angle-left" /> Data
                      </Link>
                    )}
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              {dataSet === undefined || versions === undefined ? null : (
                <div>
                  <SingleDataset
                    accountId={account.id}
                    dataSet={dataSet}
                    fetchDatasetRecordCountFunction={fetchDatasetRecordCountAction}
                    fieldSets={fieldSets}
                    handleVersionSelectChange={this.handleVersionSelectChange}
                    isProviderAdmin={isProviderAdmin}
                    isTechnicalOps={isTechnicalOps}
                    isSalesOps={isSalesOps}
                    isSuperAdmin={isSuperAdmin}
                    isAdminPage={false}
                    openConfigFormFunction={openConfigFormAction}
                    openEditListFunction={openEditListAction}
                    goToEditFieldsetFunction={goToEditFieldsetAction}
                    openFilesetPageFunction={openFilesetPageAction}
                    openFilesetPreviewFunction={openFilesetPreviewAction}
                    openDatasetReportsPageFunction={openDatasetReportsPageAction}
                    openGroupCreationFunction={openGroupCreationAction}
                    openSkuCreationFunction={openSkuCreationAction}
                    platforms={platforms}
                    recordsSummary={recordsSummary}
                    setSelectedVersion={this.setSelectedVersion}
                    selectedVersion={this.state.selectedVersion}
                    toggleDialogFunction={this.toggleDialog}
                    togglePreviewDialogFunction={this.togglePreviewDialog}
                    versionsSummary={versionsSummary}
                    datasetId={datasetId}
                  />
                  {dialog.show && dialog.id === 'viewLayoutDialog'
                    ? this.renderViewLayoutDialog()
                    : null}
                  {dialog.show && dialog.id === 'editLayoutDialog'
                    ? this.renderEditLayoutDialog()
                    : null}
                  {dialog.show && dialog.id === 'versionDialog' ? this.renderVersionDialog() : null}
                  {dialog.show && dialog.id === 'editSkuDialog' ? this.renderEditSkuDialog() : null}
                  {dialog.show && dialog.id === 'skuPreviewDialog'
                    ? this.renderPreviewDialog()
                    : null}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { account, data, dialog, superadmin, user } = state;
  const { params } = ownProps;
  const { datasetId } = params;
  const dataSet = data.get('dataset');
  const fieldSets = data.get('fieldSets');
  const recordsSummary = data.get('recordsSummary');
  const versionsSummary = data.get('versionsSummary');
  const skuFields = data.get('fields');
  const currentSkuFields = data.get('currentSkuFields');
  const currentFilesets = data.get('currentFilesets'); // Two sets, one for company, one for contact
  const isProviderAdmin = user.get('userTypeId') === PROVIDER_ADMIN;
  const isTechnicalOps = user.get('userTypeId') === PROVIDER_TECHNICAL;
  const isSalesOps = user.get('userTypeId') === PROVIDER_SALES_OPS;
  const isSuperAdmin = user.get('userTypeId') === SUPER_ADMIN;
  let platforms;
  if (superadmin) platforms = superadmin.get('platforms');
  // TODO: do we need totalRecords?
  // const totalRecords = recordsInfo.reduce((left, right) => {
  //   return left + right.count;
  // }, 0);
  return {
    account,
    dataSet,
    datasetId,
    dialog,
    fieldSets,
    isProviderAdmin,
    isTechnicalOps,
    isSalesOps,
    isSuperAdmin,
    platforms,
    recordsSummary,
    versionsSummary,
    skuFields,
    currentSkuFields,
    currentFilesets,
  };
};

export default connect(
  mapStateToProps,
  {
    clearFieldsForSkuAction: clearFieldsForSku,
    closeDialogAction: closeDialog,
    enableVersionAction: enableDatasetVersion,
    deleteVersionAction: deleteDatasetVersion,
    fetchDatasetRecordCountAction: fetchDatasetRecordCount,
    fetchDatasetsByIdAction: fetchDatasetsById,
    fetchFieldsetsByIdAction: fetchFieldsetsById,
    fetchFilesetsAction: fetchFilesets,
    fetchPlatformsAction: fetchPlatforms,
    fetchSingleDatasetByIdAction: fetchSingleDatasetById,
    fetchVersionsAction: fetchVersions,
    getFieldsForSkuAction: getFieldsForSku,
    goToEditFieldsetAction: goToEditFieldset,
    listFieldsAction: listFields,
    openConfigFormAction: openConfigForm,
    openDialogAction: openDialog,
    openEditListAction: openEditList,
    openEditSkuAction: openEditSku,
    openFilesetPageAction: openFilesetPage,
    openFilesetPreviewAction: openFilesetPreview,
    openDatasetReportsPageAction: openDatasetReportsPage,
    openGroupCreationAction: openGroupCreation,
    openSkuCreationAction: openSkuCreation,
  }
)(SingleDatasetContainer);
